module.exports = __webpack_public_path__ + "img/yt.680dbcd6.svg";